import { Snippet } from 'modules/snippets/types';
import { isMustacheStatement } from 'modules/handlebars/domain/statement/utils';
import { isNotNull } from 'utils/tsHelpers';
import { getStatements } from '../../../../../utils/getStatements';
import { getSnippetNameFromMustacheStatement } from '../../../../../utils/getSnippetNameFromMustacheStatement';

type SnippetName = Snippet['name'];

export const getInvalidSnippetNames = (snippetNames: SnippetName[], content: string) => {
  const statements = getStatements(content);
  const mustacheStatements = (statements ?? []).filter(isMustacheStatement);
  const snippetMustacheStatements = mustacheStatements.filter(getSnippetNameFromMustacheStatement);
  const snippetNamesFromMustacheStatements = snippetMustacheStatements
    .map(getSnippetNameFromMustacheStatement)
    .filter(isNotNull);
  const invalidSnippetNames = snippetNamesFromMustacheStatements.filter(
    (snippetName) => !snippetNames.includes(snippetName),
  );
  return invalidSnippetNames;
};
